import { Component } from '@angular/core';

@Component({
  selector: 'app-cta-grid',
  templateUrl: './cta-grid.component.html',
  styleUrls: ['./cta-grid.component.scss']
})
export class CtaGridComponent {}
